import { mat4, quat, vec2, vec3 } from 'gl-matrix'
import Color from '../math/Color'

export default class Renderer {
  constructor(options) {
    this.canvas = options.canvas;
    this.devicePixelRatio = options.devicePixelRatio || 1;

    this._bgColor = new Color(1, 1, 1);
    this._bgAlpha = 1;

    this.autoClear = options.autoClear === undefined? true: options.autoClear;

    let shaderPrecisionFormat;

    const webGLContextOptions = {
      antialias: options.antialias,
      premultipliedAlpha: options.premultipliedAlpha,
      alpha: true
    }

    try {
      this._gl = this.canvas.getContext('webgl', webGLContextOptions) || this.canvas.getContext('experimental-webgl', webGLContextOptions);
      shaderPrecisionFormat = this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT);
    } catch(error) {
      // console.error(error);
      this._onError('no webgl support');
      return;
    }

    if(!shaderPrecisionFormat) {
      this._onError('no highp support');
      return;
    }

    if(!this._gl) {
      this._onError('no webgl context');
      return;
    }

    // this._gl.pixelStorei(this._gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
  }

  setBgColor(color, alpha = 1) {
    this._bgColor = color;
    this._bgAlpha = alpha;
  }

  getGLContext() {
    return this._gl;
  }

  // render function
  render(rootObject, renderTarget = null) {
    renderTarget = renderTarget || this;
    renderTarget.onBeforeRender();
    this._renderObjects(rootObject);
    renderTarget.onAfterRender();
  }

  onBeforeRender() {
    if(this.autoClear) this.clear();
    this._gl.viewport(0, 0, this.canvas.width, this.canvas.height);
  }

  onAfterRender() {
    this._gl.flush();
  }

  clear() {
    this._gl.clearColor(this._bgColor.r, this._bgColor.g, this._bgColor.b, this._bgAlpha);
    this._gl.clearDepth(1);
    this._gl.clear(this._gl.COLOR_BUFFER_BIT | this._gl.DEPTH_BUFFER_BIT);
  }

  setSize(width, height) {
    this.canvas.style.width = `${width}px`;
    this.canvas.style.height = `${height}px`;
    this.canvas.width = width * this.devicePixelRatio;
    this.canvas.height = height * this.devicePixelRatio;
  }

  _renderObjects(object) {
    if (!object.isVisible) return;

    if(object.isRenderable) object.render();

    const list = this._getRenderList(object.children);
    for (let i = 0, l = list.length; i < l; i++) {
      this._renderObjects(list[i]);
    }
  }

  _getRenderList(objects) {
    if(!objects) return [];
    let list = objects.filter((object)=> { return object.isVisible });
    return list.sort((a, b)=> { return a.renderOrder - b.renderOrder });
  }

  _onError(error) {
    throw new Error(error);
  }

  dispose() {
    this.clear();
    if(this.canvas) {
      this.canvas.width = 1;
      this.canvas.height = 1;
      if(this.canvas.parentElement) this.canvas.parentElement.removeChild(this.canvas);
      this.canvas = null;
      let ext;
      if(ext = this._gl.getExtension('WEBGL_lose_context')) ext.loseContext();
      this._gl = null;
    }
  }
}
